export const AMP_FILTER_OPTIONS = ['None', 'Default', 'Mobile', 'Hover', 'Other'];
export const AMP_PLACEMENT_SWATCHES = {
  0: '#000000',
  3: '#078E42',
  6: '#277489',
  9: '#410864',
  12: '#69A7B8',
  15: '#961A06',
  18: '#BC2F1A'
};
export const AMP_PLACEMENT_URL = 'https://n.nordstrommedia.com/staging';
export const AMP_QUERIES = Object.freeze({
  ASSET_ID: 'AMP Asset ID',
  WORKFRONT_ID: 'Workfront ID'
});
export const AMP_TABS = Object.freeze({
  PLACEMENT_ONLY: 'For Placement Only',
  WEB_READY: 'Web Ready'
});
